import { SideBarDef, ToolPanelDef, useDataGridContext } from '@cmg/data-grid';
import { useMemo } from 'react';

const widthConfig = {
  width: 300,
};

const columnsToolPanelDef: ToolPanelDef = {
  id: 'columns',
  labelDefault: '',
  labelKey: 'columns',
  iconKey: 'columnsTab',
  toolPanel: 'agColumnsToolPanel',
  toolPanelParams: {
    suppressValues: true,
    suppressPivotMode: true,
    suppressRowGroups: true,
  },
  ...widthConfig,
};

const filtersToolPanelDef: ToolPanelDef = {
  id: 'filters',
  labelDefault: '',
  labelKey: 'filters',
  iconKey: 'filterTab',
  toolPanel: 'agFiltersToolPanel',
  ...widthConfig,
};

export type SideBarDefProps = Readonly<{}>;

export const useSideBarDef = () => {
  const { getOpenedToolPanel } = useDataGridContext();
  const openedToolPanel = getOpenedToolPanel() ?? undefined;

  return useMemo<SideBarDef>(() => {
    return {
      toolPanels: [filtersToolPanelDef, columnsToolPanelDef],
      defaultToolPanel: openedToolPanel,
    };
  }, [openedToolPanel]);
};
